module.exports = __webpack_public_path__ + "img/9788932023663.6e823e78.jpg";